<template>
  <div class="page-title">
    <div class="flex_row_center">
      <!-- <img class="site_img" src="https://sf-image.wjzpgz.com/minmeng/attaches/site.png" alt> -->
      <span class="title">
        <a href="/">首页 &gt;</a>
        <span v-for="(item,index) in crumbs" :key="item" href="#" @click="jumpColumn(item)">  {{ index === crumbs.length-1 ? item: item + ' > ' }}   </span>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    crumbs: Array
  },
  methods: {
    jumpColumn(columnName) {
      this.$emit('jumpColumn', columnName)
    }
  }
};
</script>

<style lang="less" scoped>
.page-title {
  background: #fff !important;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  font: 600 24px/40px PingFangHK !important;
  padding-left: 10px;
  font-family: 宋体;
  margin-top: 14px;
}
.title a{
  color: #999999;
}
.flex_row_center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
span{
  color: #0060B5;
}
.site_img {
  width: 20px;
  height: 24px;
  margin-right: 10px;
}
</style>
